import { createReducer } from "@reduxjs/toolkit";
import { getCustomerMaster } from "./ItemPageThunk";

const handleAsyncActions = (builder, action, dataKey, loadingKey, errorKey) => {
    builder
      .addCase(action.pending, (state) => {
        state.loading[loadingKey] = true;
        state[dataKey] = null;
        state.error[errorKey] = null;
      })
      .addCase(action.fulfilled, (state, action) => {
        state.loading[loadingKey] = false;
        state[dataKey] = action.payload;
        state.error[errorKey] = null;
      })
      .addCase(action.rejected, (state, action) => {
        state.loading[loadingKey] = false;
        state.error[errorKey] = action.payload;
      });
  };
  const initialState = {
    CustomerMaster: null,
  
    loading: {
      CustomerMasterLoading: false,
    },
  
    error: {
      CustomerMasterError: null,
    },
  };
  
  export const CustomerReducer = createReducer(initialState, (builder) => {
    handleAsyncActions(builder, getCustomerMaster, 'CustomerMaster', 'CustomerMasterLoading', 'CustomerMasterError');
  });
  
  export default CustomerReducer;